import React from 'react';
import PropTypes from 'prop-types';
import { getPlantHealthColor, getPlantHealthIcon, getGrowthStageColor } from './mockData';

export default function PlantDetailsPanel({ selectedPlant, plants }) {
    if (!selectedPlant) {
        return (
            <div className="plant-details-panel">
                <div className="plant-details-placeholder">
                    <i className="ri-plant-line"></i>
                    <h4>Plant Details</h4>
                    <p>Select a plant from the snapshot to view details</p>
                </div>
            </div>
        );
    }

    const plant = plants.find(p => p.id === selectedPlant);
    if (!plant) return null;

    return (
        <div className="plant-details-panel">
            <div className="plant-info">
                <div className="plant-header">
                    <h5>{plant.name}</h5>
                    <span className="plant-species">{plant.species}</span>
                </div>
                
                <div className="plant-status">
                    <span 
                        className="health-indicator"
                        style={{ 
                            backgroundColor: `${getPlantHealthColor(plant.health)}20`,
                            color: getPlantHealthColor(plant.health)
                        }}
                    >
                        <i className={getPlantHealthIcon(plant.health)}></i>
                        {plant.health}
                    </span>
                    <span 
                        className="growth-stage"
                        style={{ 
                            backgroundColor: `${getGrowthStageColor(plant.growthStage)}20`,
                            color: getGrowthStageColor(plant.growthStage)
                        }}
                    >
                        {plant.growthStage}
                    </span>
                </div>
                
                <div className="plant-notes">
                    <h6>Notes</h6>
                    <p>{plant.notes}</p>
                </div>
                
                <div className="plant-care">
                    <h6>Last Watered</h6>
                    <p>{(() => {
                        try {
                            const date = new Date(plant.lastWatered);
                            if (isNaN(date.getTime())) return 'Invalid Date';
                            return date.toLocaleDateString() + ' at ' + date.toLocaleTimeString();
                        } catch {
                            return 'Invalid Date';
                        }
                    })()}</p>
                </div>
                
                <div className="care-history">
                    <h6>Recent Care</h6>
                    <div className="care-list">
                        {plant.careHistory.slice(0, 3).map((care, index) => (
                            <div key={index} className="care-item">
                                <div className="care-date">
                                    {(() => {
                                        try {
                                            const date = new Date(care.date);
                                            return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString();
                                        } catch {
                                            return 'Invalid Date';
                                        }
                                    })()}
                                </div>
                                <div className="care-action">
                                    <span className="care-action-type">{care.action}</span>
                                    <span className="care-notes">{care.notes}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className="plant-actions">
                    <button className="plant-action-btn">
                        <i className="ri-edit-line"></i>
                        <span>Add Note</span>
                    </button>
                    <button className="plant-action-btn">
                        <i className="ri-water-line"></i>
                        <span>Mark Watered</span>
                    </button>
                    <button className="plant-action-btn">
                        <i className="ri-image-line"></i>
                        <span>View History</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

PlantDetailsPanel.propTypes = {
    selectedPlant: PropTypes.string,
    plants: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        species: PropTypes.string.isRequired,
        health: PropTypes.string.isRequired,
        growthStage: PropTypes.string.isRequired,
        lastWatered: PropTypes.string.isRequired,
        notes: PropTypes.string.isRequired,
        careHistory: PropTypes.arrayOf(PropTypes.shape({
            date: PropTypes.string.isRequired,
            action: PropTypes.string.isRequired,
            notes: PropTypes.string.isRequired
        })).isRequired
    })).isRequired
}; 